// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wi-8";
export var container = "_wi-0";
export var radioDot = "_wi-5";
export var radioDotSelected = "_wi-6";
export var row = "_wi-1";
export var rowFirst = "_wi-2";
export var rowLast = "_wi-3";
export var rowSelected = "_wi-4";
export var strikethrough = "_wi-7";